module.exports = __webpack_public_path__ + "img/dark-green-rectangle-table-4.ea22d5f3.png";